
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { LegalCaseModel } from './Entities.GormCrm.LegalCase';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class LegalCaseProductPlanModel extends Model<LegalCaseProductPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'guid', languageString: 'legalCaseProductPlan.property.productPlanId' },
		{ name: 'legalCaseId', type: 'guid', languageString: 'legalCaseProductPlan.property.legalCaseId' },
		{ name: 'legalCase', type: 'LegalCaseModel', languageString: 'legalCaseProductPlan.property.legalCase', isHidden: true, isObject: true, new: () => { return new LegalCaseModel }, properties: () => { return LegalCaseModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'legalCaseProductPlan.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public legalCaseId?: string;
	public legalCase?: LegalCaseModel;
	public productPlan?: ProductPlanModel;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.legalCaseId = undefined;
		this.legalCase = undefined;
		this.productPlan = undefined;
		
	}
	getProperties(){
		return LegalCaseProductPlanModel.classProperties;
	}
}

